import { render, staticRenderFns } from "./ApiCosts.vue?vue&type=template&id=1db734ab&scoped=true"
import script from "./ApiCosts.vue?vue&type=script&lang=js"
export * from "./ApiCosts.vue?vue&type=script&lang=js"
import style0 from "./ApiCosts.vue?vue&type=style&index=0&id=1db734ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db734ab",
  null
  
)

export default component.exports